import { render, staticRenderFns } from "./OrderItemTrackingModal.vue?vue&type=template&id=45b10138&scoped=true"
import script from "./OrderItemTrackingModal.vue?vue&type=script&lang=js"
export * from "./OrderItemTrackingModal.vue?vue&type=script&lang=js"
import style0 from "./OrderItemTrackingModal.vue?vue&type=style&index=0&id=45b10138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b10138",
  null
  
)

export default component.exports